import * as React from 'react'

const HorizontalLine = () => <hr className="horizontal-line" />

export default HorizontalLine
